import React from "react";
import classnames from "classnames";
import isEqual from "lodash/isEqual";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
//icons
import ActionPrint from "@material-ui/icons/Print";
// jazasoft
import { PageHeader, PageFooter, BackButton, showNotification } from "jazasoft";
// local
import OrderDetails from "../../OrderDetails";
import MicroController from "./MicroController";
//helpers
import { printFabricRelease } from "../../fabric/fabricHelper";
import { MicroReportId, GROUP_WISE, LAY_WISE, DEFAULT_SEPARATOR } from "../../../constants";
import { OState } from "../../../utils/types";

const styles = theme => ({
  root: {},
  container: {
    margin: "1.5em",
    padding: 0
  },
  marginVertical: {
    margin: "1.5em 0"
  },
  displayCenter: {
    display: "flex",
    justifyContent: "center",
    margin: "1.5em"
  }
});

class FabricReleaseReportView extends React.Component {
  state = {
    busy: false,
    deviationTypes: undefined
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.order, nextProps.order)) {
      const order = nextProps.order;
      const fabricIds =
        order && order.flowInfoList.flatMap(part => part.ledgerList || []).map(ledger => ledger.fabricId);
      this.props.updateFabricsDeep(fabricIds);
    }
  }

  onPrint = (orderFlow, dataType) => () => {
    const { order, fabrics } = this.props;
    if (orderFlow.stateValue >= OState.SHRINKAGE_GROUPING_COMPLETED.stateValue) {
      const part = order.flowInfoList.find(
        p =>
          p.product?.id === orderFlow.product?.id &&
          p.style === orderFlow.style &&
          p.color === orderFlow.color &&
          p.part === orderFlow.part
      );
      const ledger = part && part.ledgerList.find(l => l.lot === orderFlow.lot);
      if (ledger) {
        const fabric = fabrics[ledger.fabricId];
        const rollList = fabric.rollInfoList && fabric.rollInfoList.filter(r => r.ledgerOutId === ledger.id);
        printFabricRelease(order, orderFlow, fabric, ledger, rollList, dataType);
      }
    } else {
      this.props.dispatch(showNotification("Fabric not allocated done yet."));
    }
  };

  render() {
    const { classes, order, basePath, i18nKey, resource, orderFlowMap } = this.props;

    const orderFlowList = orderFlowMap ? Object.keys(orderFlowMap).map(key => orderFlowMap[key]) : [];

    return (
      <div className={classnames(classes.root)}>
        <PageHeader title="Fabric Release Report" />

        {order && Object.keys(order).length > 0 && (
          <div id="container" className={classes.container}>
            {/*Order Details */}
            <OrderDetails
              id="order-details"
              className={classes.border}
              record={order}
              basePath={basePath}
              resource={resource}
              i18nKey={i18nKey}
            />
            {orderFlowList.length > 0 && (
              <Paper className={classes.marginVertical} square>
                <List>
                  {orderFlowList
                    .flatMap(of =>
                      of.styleColorList
                        .sort((a, b) => (a < b ? -1 : 1))
                        .map(styleColor => ({
                          ...of,
                          styleColor,
                          style: styleColor?.split(DEFAULT_SEPARATOR)[0],
                          color: styleColor?.split(DEFAULT_SEPARATOR)[1]
                        }))
                    )
                    .map((of, idx) => (
                      <ListItem key={idx}>
                        <ListItemText>{`${of.product?.name}, ${of.style}, ${of.color}, ${of.part}, Lot${of.lot}`}</ListItemText>
                        <ListItemSecondaryAction>
                          <Button
                            edge="end"
                            aria-label="Print"
                            color="primary"
                            onClick={!this.state.busy ? this.onPrint(of, GROUP_WISE) : null}>
                            <ActionPrint style={{ marginRight: 4 }} />
                            Group Wise
                          </Button>
                          <Button
                            edge="end"
                            aria-label="Print"
                            color="primary"
                            onClick={!this.state.busy ? this.onPrint(of, LAY_WISE) : null}>
                            <ActionPrint style={{ marginRight: 4 }} />
                            Lay Wise
                          </Button>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                </List>
              </Paper>
            )}

            {orderFlowList.length === 0 && (
              <div className={classes.displayCenter}>
                <Typography color="secondary" variant="h6">
                  Report not available
                </Typography>
              </div>
            )}
            <PageFooter>
              <BackButton variant="contained" color="default" />
            </PageFooter>
          </div>
        )}
      </div>
    );
  }
}

const StyledFabricReleaseReport = withStyles(styles)(FabricReleaseReportView);

const FabricReleaseReport = props => (
  <MicroController
    requestConfig={{ params: { page: "Fabric" } }}
    microReportId={MicroReportId.FABRIC_RELEASE}
    {...props}>
    {controllerProps => <StyledFabricReleaseReport {...props} {...controllerProps} />}
  </MicroController>
);

export default FabricReleaseReport;
